// <countdown-banner> — wraps the countdown-banner (hero) section.
// Once the page is scrolled past 480px, its compact bar is moved to <body> and pinned to the bottom of
// the viewport. Dismissal is remembered per campaign in a
// cookie that expires with the countdown, and the CTAs hide when the countdown expires (optional).
if (!customElements.get('countdown-banner')) {
  customElements.define(
    'countdown-banner',
    class CountdownBanner extends HTMLElement {
      static SHOW_AFTER_Y = 480;

      connectedCallback() {
        this.hero = this.querySelector('.countdown-banner');
        this.bar = this.bar || this.querySelector('.countdown-banner__bar');
        this.dismissCookie = window.fuegoCountdown.cookieName('fuego_cd_dismissed', this.dataset.key);

        if (this.hasAttribute('data-hide-cta-when-expired')) {
          this.onExpired = () => {
            this.classList.add('is-expired');
            this.bar?.classList.add('is-expired');
          };
          this.addEventListener('countdown:expired', this.onExpired);
          this.bar?.addEventListener('countdown:expired', this.onExpired);
          // The timers may have upgraded (and already expired) before this element did.
          if (this.querySelector('countdown-timer.is-expired')) this.onExpired();
        }

        if (!this.hero || !this.bar || this.isDismissed()) return;

        this.bar.querySelector('.countdown-banner__close')?.addEventListener('click', () => this.dismiss());

        this.onScroll = () => this.setStuck(window.scrollY > CountdownBanner.SHOW_AFTER_Y);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        // Theme editor re-renders the section — take the bar back out of <body>.
        this.bar?.remove();
      }

      setStuck(stuck) {
        if (stuck && this.bar.parentElement !== document.body) {
          document.body.append(this.bar);
          void this.bar.offsetHeight; // commit the collapsed state so the first open animates
        }
        this.bar.classList.toggle('is-visible', stuck);
        this.bar.toggleAttribute('inert', !stuck);
      }

      isDismissed() {
        return window.fuegoCountdown.getCookie(this.dismissCookie) === '1';
      }

      dismiss() {
        // Stay dismissed until the visitor's countdown runs out.
        const deadline =
          parseInt(window.fuegoCountdown.getCookie(window.fuegoCountdown.cookieName('fuego_cd', this.dataset.key)), 10) ||
          Date.now() + 7 * 86400000;
        try {
          window.fuegoCountdown.setCookie(this.dismissCookie, '1', deadline);
        } catch (e) {
          // Cookies blocked — hide for this page view only.
        }
        window.removeEventListener('scroll', this.onScroll);
        this.setStuck(false);
      }
    }
  );
}
